import { render, staticRenderFns } from "./PostController.vue?vue&type=template&id=7b70fb49&"
import script from "./PostController.vue?vue&type=script&lang=js&"
export * from "./PostController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports